<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import categoryList from "./category-list";
/**
 * Customers component
 */
export default {
  components: { Layout, PageHeader, categoryList },
  data() {
    return {};
  }
};

</script>

<template>
  <Layout>
    <category-list />
  </Layout>
</template>
